const CircleRegular = () => (
  <>
    <path
      fill="currentColor"
      fillRule="evenodd"
      d="M20.5 12a8.5 8.5 0 1 1-17 0 8.5 8.5 0 0 1 17 0m-1 0a7.5 7.5 0 1 1-15 0 7.5 7.5 0 0 1 15 0"
      clipRule="evenodd"
    />
  </>
)
export default CircleRegular
